var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.891 11.0841C34.7539 5.44087 28.7312 1.6224 21.8165 1.6224C11.6664 1.6224 3.43811 9.85033 3.43811 20C3.43811 30.1497 11.6664 38.3776 21.8165 38.3776C28.7312 38.3776 34.7539 34.5591 37.891 28.9159C34.6146 35.4867 27.8298 40 19.9912 40C8.95039 40 0 31.0457 0 20C0 8.9543 8.95039 0 19.9912 0C27.8298 0 34.6146 4.51331 37.891 11.0841Z",
    fill: "#1C3699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0433 36.4046C32.6034 34.8701 38.2936 28.1865 38.2936 20.1739C38.2936 11.0269 30.8782 3.61182 21.7308 3.61182C19.6913 3.61182 17.7379 3.98043 15.9336 4.65467C17.1354 4.37676 18.3874 4.22988 19.6738 4.22988C28.8051 4.22988 36.2076 11.632 36.2076 20.763C36.2076 28.0144 31.5389 34.1755 25.0433 36.4046Z",
    fill: "#172940"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82617 14.6213C6.82617 14.6213 8.02371 11.7724 8.34242 11.4827C8.66112 11.193 10.245 10.15 11.7709 9.44503C13.2968 8.74005 15.2959 8.02543 15.2959 8.02543C15.5277 7.94817 16.3323 7.94912 16.5997 8.77868C16.8797 9.64782 16.0588 10.121 16.0588 10.121C16.0588 10.121 13.4513 10.9902 10.9403 12.1201C8.42933 13.2499 6.82617 14.6213 6.82617 14.6213Z",
    fill: "#1C3699"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95703 20.251C5.95703 20.251 6.11155 16.9289 6.33368 16.475C8.84465 14.2346 15.2863 11.6367 20.8491 10.3427C21.0905 10.2654 22.3653 10.3427 22.6647 11.6271C22.9641 12.9116 21.8245 13.4797 21.6217 13.5296C14.5358 15.2719 8.1976 18.0395 5.95703 20.251Z",
    fill: "#70A5C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18538 26.1898C6.59888 24.7882 6.35442 23.9358 6.12305 22.3077C9.19416 19.4684 18.5427 15.7601 25.9404 14.7461C28.1424 14.8333 28.6156 17.7111 26.6165 18.4931C18.1178 19.913 9.62876 23.5634 7.18538 26.1898Z",
    fill: "#1C3699"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.39 20.2705C21.93 20.2609 9.6938 25.8041 8.07129 28.0928C8.85606 29.3709 9.36167 30.048 10.3891 31.1831C10.7658 29.9663 19.6122 24.5654 30.39 23.8823C32.4471 23.4284 32.2733 20.5119 30.39 20.2705Z",
    fill: "#70A5C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5697 25.9487C21.0465 26.8662 13.0017 30.729 11.9297 32.6025C12.9765 33.4588 13.6608 33.9002 15.0974 34.6016C15.6189 32.786 22.9876 29.6957 28.9464 29.1066C30.0667 28.8362 30.8972 26.5668 28.5697 25.9487Z",
    fill: "#1C3699"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2981 31.4531C19.7877 32.8824 16.8038 34.64 16.939 35.3836C18.4746 35.9051 19.202 36.0172 20.7924 36.1562C19.9039 35.9727 21.8547 34.5144 25.0997 33.4618C25.8819 32.9693 25.6791 31.3276 24.2981 31.4531Z",
    fill: "#70A5C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/LogoFooter.f900278ee87df41e6a49a07d0fab6f13.svg";
export { ForwardRef as ReactComponent };